import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { toEmbedUrl } from '@/lib/youtube';
import { useI18n } from '@/lib/i18n';

export default function VideoPlayerModal({ open, onOpenChange, url, title }) {
  const { t } = useI18n();
  const embed = toEmbedUrl(url);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="overflow-hidden border-white/10 bg-asgym-bgdeep p-0 sm:max-w-2xl"
        data-testid="video-player-modal"
      >
        <DialogTitle className="sr-only">{title || t('video.play')}</DialogTitle>
        <div className="flex items-center gap-2 border-b border-white/[0.06] px-4 py-3">
          <span className="h-2 w-2 rounded-full bg-asgym-accent" />
          <p className="truncate text-sm font-bold text-white">{title || t('video.play')}</p>
        </div>
        <div className="relative w-full bg-black" style={{ aspectRatio: '16 / 9' }}>
          {embed ? (
            <iframe
              src={embed}
              title={title || 'video'}
              className="absolute inset-0 h-full w-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              data-testid="video-iframe"
            />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center text-sm text-asgym-sub">
              {t('video.noVideo')}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
